export default "__VITE_ASSET__250843a3__"